<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<coso-replicator-page-header [title]="'Explicit Folder Permissions'"></coso-replicator-page-header>
@if (isSaaS === false && isFailoverBackupInstance) {
<alert type="warning">
  <coso-alert-message> This configuration is taken automatically from main instance, and therefore is read-only. </coso-alert-message>
</alert>
} @if (isSaaS === false && isRunning) {
<alert type="warning">
  <coso-alert-message> You can only modify the content of this page once the replication process is stopped. </coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if ({ isLoading: loadingService.isAnySpinnerActive$ | async }; as loadingState) { @if (!loadingState.isLoading) {
<coso-grid [gridOptions]="gridOptions" [columnDefs]="columnDefs" [rowData]="rowData">
  <div topBarLeft>
    <button
      id="createButton"
      class="btn btn-primary mr-2"
      (click)="openCreateModal()"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Create a new explicit folder permission"
      [disabled]="isReadOnly || initFailed"
    >
      <span class="fa fa-plus mr-1" aria-hidden="true"></span>Create new
    </button>
    <button
      class="btn btn-danger"
      (click)="removeSelected()"
      data-toggle="tooltip"
      data-placement="top"
      data-original-title="Remove these Explicit Folder Permissions. This action cannot be undone."
      [disabled]="isReadOnly || selectedRows.length == 0"
    >
      <span class="fa fa-trash mr-1" aria-hidden="true"></span>Remove selected
    </button>
  </div>
</coso-grid>
<a class="btn btn-dark mt-5" [routerLink]="['/', 'configuration', instanceId, 'connections']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Connections list</a>
} }

<ng-template #actionButtons let-params="params">
  <div class="grid-btnActions btn-group-sm">
    <button
      id="editActionButton#{{ params.node.rowIndex }}"
      class="btn btn-dark"
      (click)="openEditModal(params)"
      data-toggle="tooltip"
      data-placement="top"
      title="Edit explicit folder permission"
      [disabled]="isReadOnly"
      [attr.aria-label]="'Edit explicit folder permission (row#' + params.node.rowIndex + ')'"
    >
      <span class="fa fa-pencil" aria-hidden="true"></span>
    </button>
  </div>
</ng-template>
